import React from 'react';

const Kompetenzen = () => {
    return (
        <>
            <section className="resume-section" id="skills">
                <div className="resume-section-content">
                    <h2 className="mb-5 text-primary">Kompetenzen</h2>
                    <div className="subheading mb-3">Programmiersprachen & Tools</div>
                    <ul className="list-inline dev-icons">
                        <li className="list-inline-item"><i className="fab fa-html5"></i></li>
                        <li className="list-inline-item"><i className="fab fa-css3-alt"></i></li>
                        <li className="list-inline-item"><i className="fab fa-js-square"></i></li>
                        <li className="list-inline-item"><i className="fab fa-bootstrap"></i></li>
                        <li className="list-inline-item"><i className="fab fa-angular"></i></li>
                        <li className="list-inline-item"><i className="fab fa-react"></i></li>
                        <li className="list-inline-item"><i className="fab fa-node-js"></i></li>
                        <li className="list-inline-item"><i className="fab fa-sass"></i></li>
                        <li className="list-inline-item"><i className="fab fa-npm"></i></li>
                    </ul>

                </div>
            </section>
            <hr className="m-0" />
        </>
    )
};

export default Kompetenzen;